// IELTS Mock 3 — Listening (IELTS Fever Listening Practice Test 4)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// Groups with `flow` render as a flow-chart: steps with a `qid` hold that question,
// steps with only `text` are fixed boxes.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening3.mp3";

const IELTS_MOCK3_LISTENING = {
  title: "IELTS Listening Mock 3",
  sections: [
    {
      id: "s1",
      title: "Section 1: Car Rental Inquiry",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 1–10: Complete the notes below. Write ONE WORD AND/OR A NUMBER for each answer.",
          heading: "Car Rental Inquiry",
          example: { q: "Nationality: American" },
          image: null,
          questions: [
            { id: "q1", text: "Contact number: ______", type: "fill_blank", answer: ["04196570156", "4196570156"] },
            { id: "q2", text: "Send a written quote by: ______", type: "fill_blank", answer: ["post"] },
            { id: "q3", text: "Price for renting: ______ daily", type: "fill_blank", answer: ["39", "$39", "39 dollars"] },
            { id: "q4", text: "Special requirements for the room: an extra ______", type: "fill_blank", answer: ["bed", "beds"] },
            { id: "q5", text: "Special requirements for the room: most important facility: ______", type: "fill_blank", answer: ["kitchen"] },
            { id: "q6", text: "Extra equipment: they should have a ______", type: "fill_blank", answer: ["heater"] },
            { id: "q7", text: "Extra equipment: as well as a ______", type: "fill_blank", answer: ["microwave"] },
            { id: "q8", text: "Pick them up from the ______", type: "fill_blank", answer: ["airport"] },
            { id: "q9", text: "The caravan driver's age: ______", type: "fill_blank", answer: ["49"] },
            { id: "q10", text: "The registered licence issued in: ______", type: "fill_blank", answer: ["australia"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Cocoa Beans and Coffee",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–16: Complete the flow-chart below. Write ONE WORD ONLY for each answer.",
          heading: "Harvesting and Processing Cocoa Beans",
          image: null,
          flow: [
            { qid: "q11" },
            { qid: "q12" },
            { qid: "q13" },
            { text: "After being roasted at a high temperature" },
            { qid: "q14" },
            { qid: "q15" },
            { qid: "q16" },
          ],
          questions: [
            { id: "q11", text: "Chocolate beans are ______ and then bags are shipped.", type: "fill_blank", answer: ["harvested"] },
            { id: "q12", text: "Bags are then ______ and weighed by machines.", type: "fill_blank", answer: ["opened"] },
            { id: "q13", text: "Next chocolate beans are ______ in a hopper.", type: "fill_blank", answer: ["cleaned"] },
            { id: "q14", text: "Boiled chocolate beans are ______ and cracked.", type: "fill_blank", answer: ["expanded"] },
            { id: "q15", text: "Roasted beans needs to be ______.", type: "fill_blank", answer: ["cooled"] },
            { id: "q16", text: "Roasted beans are ______ in the pocket.", type: "fill_blank", answer: ["sealed"] },
          ],
        },
        {
          instruction:
            "Questions 17–20: What does each type of coffee taste like? Write the correct letter, A–D, next to Questions 17–20.",
          image: null,
          optionsBox: ["A. intense", "B. mild", "C. chocolaty", "D. smoky"],
          mapOptions: ["A", "B", "C", "D"],
          questions: [
            { id: "q17", text: "First Crack", type: "map", answer: "B" },
            { id: "q18", text: "Green Beans", type: "map", answer: "D" },
            { id: "q19", text: "French Roast", type: "map", answer: "C" },
            { id: "q20", text: "Espresso Smoky", type: "map", answer: "A" },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Talking about the Moa",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–26: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "What is the thing makes Moa similar to a dinosaur?",
              type: "mcq",
              options: [
                "A. Both are of interest to the public.",
                "B. Both are extinct at similar time.",
                "C. Both left lots of fossil remains.",
              ],
              answer: "A",
            },
            {
              id: "q22",
              text: "What is the difference between Moa and other birds?",
              type: "mcq",
              options: ["A. no wing bones", "B. a long tail", "C. a smaller head"],
              answer: "A",
            },
            {
              id: "q23",
              text: "What's the special feature of their chicks?",
              type: "mcq",
              options: [
                "A. They never return to the nests.",
                "B. Most of them die within two months after birth.",
                "C. They can find food by themselves.",
              ],
              answer: "C",
            },
            {
              id: "q24",
              text: "What is the tutor's opinion on male hatching the eggs?",
              type: "mcq",
              options: [
                "A. She doubts whether it is true or possible.",
                "B. She thinks it may be true.",
                "C. She can say with certainty that is true.",
              ],
              answer: "B",
            },
            {
              id: "q25",
              text: "What is the male student's response after hearing some people see a Moa recently?",
              type: "mcq",
              options: ["A. He is surprised.", "B. He is worried.", "C. He is amused."],
              answer: "C",
            },
            {
              id: "q26",
              text: "Why did Moa become extinct?",
              type: "mcq",
              options: [
                "A. A climate change",
                "B. human interface",
                "C. competitions with other animals",
              ],
              answer: "B",
            },
          ],
        },
        {
          instruction:
            "Questions 27–30: What is the feature of different types of Moa? Choose FOUR answers from the box and write the correct letter, A–F, next to Questions 27–30.",
          image: null,
          optionsBox: [
            "A. the much taller female",
            "B. less fossils left",
            "C. the biggest eggs",
            "D. feeding at night",
            "E. poor eyesight",
            "F. better vocal sound",
          ],
          mapOptions: ["A", "B", "C", "D", "E", "F"],
          questions: [
            { id: "q27", text: "the North Island Giant Moa", type: "map", answer: "A" },
            { id: "q28", text: "the Crested Moa", type: "map", answer: "B" },
            { id: "q29", text: "the Stout-legged Moa", type: "map", answer: "F" },
            { id: "q30", text: "the Eastern Moa", type: "map", answer: "E" },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Time Measurement",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–35: Complete the notes below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "History of time-measurement",
          image: null,
          questions: [
            { id: "q31", text: "Primitive measurements by observing — Two time keepers: the ______", type: "fill_blank", answer: ["sun's position", "sun position"] },
            {
              id: "q32",
              text: "Primitive measurements by observing — Natural events, such as winds and rains, rivers flooding, plants flowering, and the cycles of breeding or ______ behaviour.",
              type: "fill_blank",
              answer: ["animal", "animals"],
            },
            { id: "q33", text: "Precise measurements — They became important for organising activities for: ______", type: "fill_blank", answer: ["religion", "religions"] },
            { id: "q34", text: "Precise measurements — They became important for organising activities for: ______", type: "fill_blank", answer: ["government", "the government"] },
            { id: "q35", text: "The oldest time keepers were discovered in Mesopotamia and ______", type: "fill_blank", answer: ["north africa"] },
          ],
        },
        {
          instruction:
            "Questions 36–40: Complete the table below. Write ONE WORD ONLY for each answer.",
          heading: "Time keepers and their disadvantages",
          image: null,
          questions: [
            { id: "q36", text: "The sundial — In different parts of the year, the time for day ______", type: "fill_blank", answer: ["varied"] },
            { id: "q37", text: "The clepsydra (water clock) — The changing pressure and ______ were what the flow of water still relied on.", type: "fill_blank", answer: ["temperature"] },
            { id: "q38", text: "Time keeper: The ______", type: "fill_blank", answer: ["sandglasses", "sandglass"] },
            { id: "q39", text: "Disadvantage: The time duration was ______", type: "fill_blank", answer: ["limited"] },
            { id: "q40", text: "Fire candle clock — The burning ______ or the rate of burning, was subject to the candles wax.", type: "fill_blank", answer: ["time"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK3_LISTENING;
